import axios from '@/app/plugins/Axios';
import { PAGINATION_OPTIONS } from "@/app/vuetifyConfig";

export default {
    namespaced: true,
    state: {
      pedidocompra: {
        itens: [],
        observacoes: ''
      },
      pedidoscompra: [],
      total_de_registros: 0,
      item: {
          entradas: []
      },
      search: "",
      pagination: PAGINATION_OPTIONS,
    },

    mutations: {
        SET_PEDIDOSCOMPRA(state, pedidoscompra) {
          state.pedidoscompra = pedidoscompra;
        },

        SET_PEDIDOCOMPRA(state, pedidocompra) {
          state.pedidocompra = pedidocompra;
        },

        SET_PEDIDOCOMPRA_ITEM(state, item) {
          state.item = item;
        },
        UNSET_PEDIDOCOMPRA(state) {
            state.pedidocompra = {
              itens: [],
              observacoes: ''
            };
        },

        EXCLUIR_PEDIDOCOMPRA(state, id) {
            let index = state.pedidoscompra.findIndex((pedidocompra) => pedidocompra.id == id);
            if (index > -1) {
                state.pedidoscompra.splice(index, 1);
            }
        },

        UPDATE_PAGINATION(state, pagination) {
          state.pagination = pagination;
        },

        SET_SEARCH(state, search) {
          state.search = search;
        },

        SET_TOTAL(state, total) {
          state.total_de_registros = total;
        },
    },

    actions: {
        async listar({ commit, state }) {
            try {
              const { sortBy, sortDesc, page, itemsPerPage } = state.pagination;

              const parametros = {
                ...state.filtro,
                page,
                search: state.search,
                itemsPerPage,
                sortBy: sortBy[0],
                sortDesc: sortDesc[0],
              };

                commit("LOADING_ON", null, { root: true });
                const response = await axios.get("/pedidoscompra", { params: parametros }).then(response => response.data);
                commit("SET_PEDIDOSCOMPRA", response.data);
                commit("SET_TOTAL", response.total);
            } catch (error) {
                throw error;
            } finally {
                commit("LOADING_OFF", null, { root: true });
            }
        },

        async abrir({ commit }, id) {
            try {
                commit("LOADING_ON", null, { root: true });
                const response = await axios.get(`/pedidoscompra/${id}`).then(response => response.data);
                commit("SET_PEDIDOCOMPRA", response);
            } catch (error) {
                throw error;
            } finally {
                commit("LOADING_OFF", null, { root: true });
            }
        },

        async getPedidoCompraItem({ commit }, item) {
            try {
                commit("LOADING_ON", null, { root: true });
                const response = await axios.get(`/pedidoscompra/${item.pedido_compra_id}/item/${item.id}`).then(response => response.data);
                commit("SET_PEDIDOCOMPRA_ITEM", response);
            } catch (error) {
                throw error;
            } finally {
                commit("LOADING_OFF", null, { root: true });
            }
        },

        async salvar({ commit }, pedidocompra) {
            try {
                commit("LOADING_ON", null, { root: true });
                const response = await axios.post("/pedidoscompra", pedidocompra).then(response => response.data);
                return response;
            } catch (error) {
                throw error;
            } finally {
                commit("LOADING_OFF", null, { root: true });
            }
        },

        async atualizar({ commit }, pedidocompra) {
            try {
                commit("LOADING_ON", null, { root: true });
                const response = await axios.put(`/pedidoscompra/${pedidocompra.id}`, pedidocompra).then(response => response.data);
                return response;
            } catch (error) {
                throw error;
            } finally {
                commit("LOADING_OFF", null, { root: true });
            }
        },

        async excluir({ commit }, pedidocompra) {
          try {
            commit("LOADING_ON", null, { root: true });
            const response = await axios.delete(`/pedidoscompra/${pedidocompra.id}/excluir`).then(response => response.data);
            commit("EXCLUIR_PEDIDOCOMPRA", pedidocompra.id);
            return response;
          } catch (error) {
              throw error;
          } finally {
              commit("LOADING_OFF", null, { root: true });
          }
        },
    },
}